<template>
  <div class="component-input-file" :class="{ slim: isSlim }">
    <div class="row align-items-end mb-5">
      <div class="col-lg-12">
        <div class="container-upload-file">
          <!-- Upload -->
          <div class="upload-file">
            <img src="@/assets/images/btn-stars.png" alt="" v-if="!isSlim" />
            <i class="icon-file-text" :class="{ 'mb-6 mb-lg-3': !isSlim }"></i>
            <div v-if="fileName">{{ fileName }}</div>
            <div v-else class="text-primary font-weight-bold">
              {{ title }}
            </div>
            <span class="text-secondary small-text d-none d-lg-block mt-3">
              Arraste para cá ou selecione.
            </span>
            <span class="text-secondary small-text d-none d-lg-block mt-4">
              CSV/XLSX de até 5MB
            </span>
            <input
              id="input-file"
              type="file"
              class="input-file"
              @change="fileChange($event.target.files)"
            />
          </div>
          <!-- Success -->
          <div v-if="value" class="container-file">
            <button class="btn edit-file" type="button" @click="changeFile">
              <i class="fa-solid fa-pen"></i>
            </button>
            <button class="btn remove-file" type="button" @click="resetFile">
              <i class="icon-x"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-12 pl-lg-0 d-lg-none" v-if="!isSlim && description">
        <div class="file-description p-3 mt-5">
          <span class="text-secondary small-text">
            {{ description }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="file-description p-3 mt-5 d-none d-lg-block"
      v-if="!isSlim && description"
    >
      <span class="text-secondary small-text">
        {{ description }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Arquivo"
    },
    description: {
      type: String,
      default: ""
    },
    value: {
      type: [File, String],
      default: null
    },
    isSlim: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      fileName: ""
    };
  },
  computed: {
    isValid() {
      let valid = false;
      for (const key in this.form) {
        valid = Array.isArray(this.form[key])
          ? this.form[key].length
          : !!this.form[key];
      }
      return valid;
    }
  },
  methods: {
    changeFile() {
      document.getElementById("input-file").click();
    },
    resetFile() {
      this.$emit("input", null);
      document.getElementById("input-file").type = "text";
      document.getElementById("input-file").type = "file";
      this.fileName = null;
    },
    fileChange(files) {
      if (!files) return;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      const i = parseInt(Math.floor(Math.log(files[0].size) / Math.log(1024)));
      const size =
        Math.round(files[0].size / Math.pow(1024, i), 2) + " " + sizes[i]; // convert to mb and show unit meansurement

      if (size.match("MB") && /([^MB]*)MB/.exec(size)[1] > 5) {
        this.$message.error("O arquivo deve ter no máximo 5 mb");
        return;
      }

      this.getFile(files[0]).then(file => {
        this.fileName = files[0].name;
        this.$emit("input", file);
      });
    },
    getFile(file) {
      return new Promise(resolve => {
        const fReader = new FileReader();

        fReader.onload = () => {
          resolve(fReader.result);
        };

        fReader.readAsDataURL(file);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.component-input-file {
  .upload-file {
    padding: 56px 16px 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: rgba($color: #5576ec, $alpha: 0.05);
    border-radius: 4px;
    height: 100%;
    position: relative;

    img {
      position: absolute;
      left: 50%;
      top: 50px;
      transform: translateX(-50%);
    }

    i {
      font-size: 56px;
      margin-bottom: 30px;
      color: #5576ec;
    }

    @media screen and (max-width: 991px) {
      padding: 26px 10px 22px;

      div {
        font-size: 12px;
      }

      i {
        font-size: 46px;
        margin-bottom: 10px;
        color: #5576ec;
      }
    }
  }

  .container-file {
    display: flex;

    .edit-file,
    .remove-file {
      min-width: 24px;
      min-height: 24px;
      max-width: 24px;
      max-height: 24px;
      background-color: #393444;
      position: absolute;
      color: #fff;

      display: flex;
      justify-content: center;
      align-items: center;

      i {
        max-width: 24px;
      }
    }

    .edit-file {
      right: 60px;
      top: 12px;
    }
    .remove-file {
      right: 24px;
      top: 12px;
    }
  }

  .container-upload-file {
    border: 1px dashed #d2d0d8;
    border-radius: 4px;
    max-width: 100%;
  }

  .file-description {
    background: #fff;
    border-radius: 8px;
    line-height: 15px;
    width: 225px;
    max-width: 100%;
    @media screen and (max-width: 991px) {
      width: 100%;
    }
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 100%;
    margin-bottom: 10%;
    position: absolute;
    cursor: pointer;
  }

  &.slim {
    .upload-file {
      padding: 12px 24px 9px;
      flex-direction: row;
      justify-content: flex-start;

      @media screen and (min-width: 991px) {
        flex-wrap: wrap;
      }

      i {
        font-size: 24px;
        margin-bottom: 0px;
        margin-right: 10px;
      }
    }

    .text-primary {
      font-size: 14px;
    }
    .container-upload-file {
      border: 1px solid #d2d0d8;
      height: 64px;
      width: 100%;
    }

    .input-file {
      margin-bottom: 0;
      margin-left: -5%;
    }
  }
}
</style>
